import {
  buildDeserializer,
  buildSerializer,
  SerializeMap,
} from "lib/serializerUtils";

export const manualAdjustmentSerializeMap: SerializeMap<ManualAdjustment> = {
  billingReference: "billing_reference",
  created: "created",
  createdFromDocumentId: "created_from_document_id",
  billingSettingsId: "billing_settings_id",
  emailAttachmentsToFromBusiness: "email_attachments_to_from_business",
  emailAttachmentsToToBusiness: "email_attachments_to_to_business",
  fromBusinessId: "from_business_id",
  glCode: "gl_code",
  gstCents: "gst_cents",
  gstMethod: "gst_method",
  id: "id",
  labels: "labels",
  livestockSaleId: "livestock_sale_id",
  note: "note",
  subtotalCents: "subtotal_cents",
  sundryTemplateId: "sundry_template_id",
  taxType: "tax_type",
  templateLabel: "template_label",
  toBusinessId: "to_business_id",
  totalCents: "total_cents",
};

export const serializeManualAdjustment = buildSerializer(
  manualAdjustmentSerializeMap,
  "manualAdjustment",
);
export const deserializeManualAdjustment = buildDeserializer(
  manualAdjustmentSerializeMap,
  "manualAdjustment",
);
